"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayNameValidationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@framework/constants");
exports.displayNameValidationSchema = (0, yup_1.string)()
    .min(constants_1.displayNameMinLength, "form.validations.tooShort")
    .max(constants_1.displayNameMaxLength, "form.validations.tooLong")
    .required("form.validations.valueMissing");
//# sourceMappingURL=display-name.js.map